import React from 'react';
import useNetwork from '../../hooks/useNetwork';
import Card from '../../components/Card';

export default function GoogleDrive(props) {
  const network = useNetwork();

  return (
    <Card className="p-4">
      <div className="flex flex-col space-y-2">
        <div className="space-y-0.5">
          <div className="text-lg font-semibold text-cs-gray-900">
            Google Drive Link
          </div>
          <div className="text-base text-cs-gray-500 line-clamp-3">
            Here is your network's customized Google Drive link for you to reference tools
            and resources shared or developed as part of your CommunityShare onboarding and
            coaching experience.
          </div>
          {network.data.googleDriveUrl ? (
            <a
              href={network.data.googleDriveUrl}
              target="_blank"
              className="block pt-4 text-cs-orange-500 hover:text-cs-orange-300"
            >
              {network.data.googleDriveUrl}
            </a>
          ) : (
            <div className="pt-4 text-gray-500">
              [No link provided]
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
